<template>
    <div class="container">
        <van-nav-bar :title="projectInfo && projectInfo.community.name" left-text="" right-text="新增" left-arrow
            @click-left="onClickLeft" @click-right="changePage('')">
        </van-nav-bar>

        <div class="box-title" v-if="projectInfo">基本信息</div>
        <div class="list-box" v-if="projectInfo">
            <div class="list clearfix">
                <div class="fl_left">
                    <div class="mg10">项目：{{ projectInfo.community && projectInfo.community.city &&
                        projectInfo.community.city.name }}
                        {{ projectInfo.community &&
                            projectInfo.community.name }} </div>
                    <div class="">时间：{{ projectInfo.createTime }}</div>
                </div>
                <div class="fl_right">
                    <div class="mg10">
                        <span class="" v-if="projectInfo.status == 0">{{ statusList[projectInfo.status].name }}</span>
                        <span class="col_g" v-if="projectInfo.status == 1">{{ statusList[projectInfo.status].name }}</span>
                        <span class="col_r" v-if="projectInfo.status == 2">{{ statusList[projectInfo.status].name }}</span>

                    </div>
                </div>
            </div>
        </div>
        <div class="box-title" v-if="projectInfo">设备信息</div>
        <van-list v-model="loading" :finished="finished" :finished-text="projectList.length > 0 ? '没有更多了' : '暂无数据'"
            @load="onLoad">
            <div class="list-box">
                <div class="list clearfix" @click="changePage(item)" :key="index" v-for="(item, index) in projectList">
                    <div class="fl_left">
                        <div class="mg10">设备编码：{{ item.device && item.device.mainNo }}</div>
                        <div class="">时间：{{ item.createTime }}</div>
                    </div>
                    <div class="fl_right">
                        <div class="mg10">
                            <span class="" v-if="item.status == 0">{{ statusList[item.status].name }}</span>
                            <span class="col_g" v-if="item.status == 1">{{ statusList[item.status].name }}</span>
                            <span class="col_r" v-if="item.status == 2">{{ statusList[item.status].name }}</span>
                            <img src="../../assets/img/sel_right.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </van-list>

    </div>
</template>
    
<script>
import axios from '@/axios.js';
import { NavBar, Icon, Image, Toast, Loading, Picker, Field, Popup, List, } from 'vant';
export default {
    data() {
        return {
            projectId: null,
            allCount: 0,
            pageIndex: 1,
            pageSize: 10,
            loading: false,
            finished: false,
            projectList: [],
            projectInfo: null,
            status: undefined,

            statusList: [
                { name: '待审核', value: 0 },
                { name: '已通过', value: 1 },
                { name: '未通过', value: 2 },
            ],
        };
    },
    components: {
        [NavBar.name]: NavBar,
        [Icon.name]: Icon,
        [Image.name]: Image,
        [Toast.name]: Toast,
        [Loading.name]: Loading,
        [Field.name]: Field,
        [Picker.name]: Picker,
        [Popup.name]: Popup,
        [List.name]: List
    },
    methods: {
        changePage(item) {
            if (!item) {
                this.$router.push({ path: "createDevice.html", query: { communityId: this.projectInfo.communityId, projectId: this.projectId } })
            } else {
                this.$router.push({ path: "constructionDetail.html", query: { id: item.id, mainNo: item.device.mainNo, projectId: this.projectId, status: item.status } })
            }
        },
        onLoad() {
            // 异步更新数据
            setTimeout(() => {
                this.pageIndex++;
                this.getMoreList();
            }, 500)
        },
        getProjectInfo() {
            axios.post("/constructioncommunity/getinfobyid?id=" + this.$route.query.id, {}).then((res) => {
                this.projectInfo = res.data && res.data[0];
            })
        },
        getDeviceList() {
            this.loading = true;
            axios.post("/constructiondevice/pagelist", {
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                filter: {
                    constructionCommunityId: this.$route.query.id
                }
            }).then((res) => {
                // 加载状态结束
                this.loading = false;
                this.projectList = res.data.list;
                this.allCount = res.data.total;
                this.statistics = res.data.statistics;
            })
        },
        getMoreList() {
            axios.post("/constructiondevice/pagelist", {
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                filter: {
                    constructionCommunityId: this.$route.query.id
                }
            }).then((res) => {
                this.projectList = this.projectList.concat(res.data.list);
                this.allCount = res.data.total;
                // 加载状态结束
                this.loading = false;
                // 数据全部加载完成
                if (this.pageIndex * this.pageSize >= this.allCount) {
                    this.finished = true;
                }
            })
        },
        onClickLeft() {
            this.$router.go(-1);
        },
        onClickRight() {
        },
    },
    computed: {
    },
    created() {
        this.projectId = this.$route.query.id;
        this.getDeviceList();
        this.getProjectInfo();
    },
    mounted() { },
    destroyed() { }
}
</script>
<style lang="less" scoped>
body,
html {
    width: 100%;
    height: 100%;
    background: #F0F4F7
}

.container {
    width: 100%;
    height: 100%;
    letter-spacing: 0px;
    background: #F0F4F7;
}

.box-title {
    font-weight: bold;
    margin-left: 10px;
    margin-top: 10px;
}

.list-box {
    width: 100%;
    color: #373737;

    .list {
        font-size: 14px;
        width: 100%;
        background: #fff;
        margin: 12px 0;
        padding: 12px;

        .fl_right {
            text-align: right;
            margin-top: 15px;

            img {
                width: 6px;
                margin-left: 8px;
                margin-bottom: 2px;
                vertical-align: middle;
            }
        }
    }

    .mg10 {
        margin-bottom: 10px;
    }

    .bold {
        font-weight: bold;
    }
}
</style>
    